<script>

/* COMPOSANTS */
import AkFormList from "@components/layout/AkFormList";
import AkDropdown from "@components/input/AkDropdown";
import AkInputText from "@components/input/AkInputText";
import AkInputTextArea from "@components/input/AkInputTextArea";
import AkCheckbox from "@components/input/AkCheckbox";
import AkDropdownMultiple from "@components/input/AkDropdownMultiple";
import AkDateTime from "@components/input/AkDateTime";
import AkInputMask from "@components/input/AkInputMask";
import AkDialog from "@components/general/AkDialog";
import AkYesNoButton from "@components/input/AkYesNoButton";
import AkCalendar from "@components/input/AkCalendar";
import ProgressSpinner from 'primevue/progressspinner';
import Button from 'primevue/button';
import Tag from 'primevue/tag';

/* MIXINS */
import randomRef from "@mixins/randomRef";
import utilsMixin from "@mixins/utilsMixin";
import dateFormatter from "@mixins/dateFormatter";
import roleMixin from "@mixins/roleMixin";
import precisionTypeInterventionMixin from "@mixins/precisionTypeInterventionMixin";
import validationStatusConst from "@mixins/const/validationStatusConst";
import sensConst from "@mixins/const/sensConst";
import origineAppelConst from "@mixins/const/origineAppelConst";
import voieConst from "@mixins/const/voieConst";
import typeInterventionConst from "@mixins/const/typeInterventionConst";

/* SERVICES */
import interventionService from "@services/interventionService";
import ceiService from "@services/ceiService";
import axeInterventionService from "@services/axeInterventionService";
import userSettingsService from "@services/userSettingsService";
import affectationService from "@services/affectationService";
import agerService from "@services/agerService";
import uerService from "@services/uerService";
import typeAxeInterventionConst from "@mixins/const/typeAxeInterventionConst";
import typeEchangeurInterventionConst from "@mixins/const/typeEchangeurInterventionConst";

export default {
  components: {
    AkCalendar,
    AkYesNoButton,
    AkDialog,
    AkInputMask,
    AkDateTime, 
    AkDropdownMultiple, 
    AkCheckbox, 
    AkDropdown, 
    AkInputTextArea, 
    AkInputText, 
    AkFormList,
    Tag,
    Button,
    ProgressSpinner,
  },
  mixins: [
    dateFormatter,
    origineAppelConst,
    precisionTypeInterventionMixin,
    randomRef,
    roleMixin,
    sensConst,
    typeInterventionConst,
    utilsMixin,
    voieConst,
    validationStatusConst,
      typeAxeInterventionConst,
      typeEchangeurInterventionConst,
  ],
  metaInfo() {
    return {
      title: "Fiches des interventions",
    }
  },
  data() {
    return {
      loading: true,
      intervLoading: true,
      submitted: false,
      interventions: [],
      axeInterventionList: [],
      axeInterventionAutorouteList: [],
      newIntervention: [
        {
          ceiId: '',
          callDate: '',
          callTime: '',
          callOrigin: '',
          axeInterventionId: '',
          sens: '',
          voie: '',
          heureArriveeSite: '',
          heureDepartSite: '',
          localisation: '',
          typeIntervention: '',
          precisionNiveau1: '',
          sensListTmp: [],
          inciviliteAgression: false,
        }
      ],
      currentUser: roleMixin.currentUser,
      userSettings: {},
      userCeis: [],
      userUers: [],
      userAgers: [],
      precision1: false,
      creationErrors: {},
      editionErrors: {},
      showOnlyMine: false,
      current: null,
      totalRecords: 100,
      paginateOptions: null,
      prValidatorRegexpFormat: "^[0-9]*\\.{0,1}[0-9]*$",
      isExportDownloading: false,
      isFullExportDownloading: false,
      isCustomExportDownloading: false,
      displayCreateLightIntervention: false,
      searchContent: "",
      selectedRows: new Set(),
      selectAll: false,
      reloadListTimeout: null,
      presenceRi: false,
      ddp: false,
      callOrigin: null,
      axeInterventionId: null,
      sens: null,
      typeIntervention: null,
      author: "",
      filterAgerId: null,
      filterUerId: null,
      filterCeiId: null,
      filterStatus: null,
      yesNoEmpty: [
        {label: this.$t('yes'), value: true},
        {label: this.$t('no'), value: false},
        {label: this.$t('undefined_short'), value: null},
      ],
      statusList: [
        {label: 'Validé', value: 'VALIDATED'},
        {label: 'En rédaction', value: 'REDACTION'},
      ],
      startDate: null,
      endDate: null,
      noInterCei: "",
      inciviliteAgression: null,
      tableSettings: [],
      tmpTableSettings: [],
      origineAppel: null,
      lieuIntervention: null,
      intervention: null,
      environnement: null,
      origineAppelDropdown: false,
      lieuInterventionDropdown: false,
      interventionDropdown: false,
      environnementDropdown: false,
      agerList: [],
      uerList: [],
      ceiList: [],
      noInterDirif: "",
    }
  }
  ,
  mounted() {
    this.showOnlyMine = this.isUserGroupRiCEI();
    this.paginateOptions = this.userParamsIntervention?.paginateOptions;
    
    this.reloadInterventions();

    let p1 = axeInterventionService.findAll();
    p1.then(data => {
      this.axeInterventionList = data;
      this.axeInterventionAutorouteList = data.filter(axe => axe.autoroute);
    });

    let p2 = userSettingsService.getTableInterventionSettings(this.currentUser.userId);
    p2.then(data => {
      this.tableSettings = data;
    })

    let p3 = affectationService.findAllByUserId(this.currentUser.userId);
    p3.then(data => {
      this.userCeis = data.ceiList;
      this.userUers = data.uerList;
      this.userAgers = data.agerList;
      this.reset();
    });
    
    Promise.all([p1, p2, p3]).then(() => {
      this.reloadAgerUerCeiLists().then(() => {
        this.loading = false;
      });
    });
  }
  ,
  methods: {
    setupEditionErrors() {
      this.interventions.forEach(intervention => {
        this.editionErrors[intervention.id] = {};
      });
    },
    reloadAgerUerCeiLists() {
      let p5 = agerService.findAllCurrent().then(data => this.agerList = data);
      let p6 = uerService.findAllCurrent().then(data => {
        if (this.filterAgerId != null) this.uerList = data.filter(val => val.agerId === this.filterAgerId);
        else this.uerList = data;
      });
      let p7 = ceiService.findAllCurrent().then(data => {
        if (this.filterAgerId != null) data = data.filter(val => val.agerId === this.filterAgerId);
        if (this.filterUerId != null) data = data.filter(val => val.uerId === this.filterUerId);
        this.ceiList = data;
      });

      return Promise.all([p5, p6, p7]);
    },
    isUndefinedOrEmpty(value) {
      return value === undefined || value === null || value === '';
    },
    getErrors(intervention, forValidation) {
      let errors = {}
      if (intervention.callOrigin === '' || intervention.callOrigin === null) {
        errors.callOrigin = 'L\'origine de l\'appel est obligatoire'
      }
      if (intervention.localisation === '' || intervention.localisation === null) {
        errors.localisation = 'La localisation est obligatoire'
      }
      if (intervention.ceiId === '' || intervention.ceiId === null) {
        errors.ceiId = 'Le CEI est obligatoire'
      }
      if (intervention.axeInterventionId === '' || intervention.axeInterventionId === null) {
        errors.axeInterventionId = 'L\'axe d\'intervention est obligatoire'
      }

      // Si Bretelle est sélectionné, on attend un numéro
      if (this.isUndefinedOrEmpty(intervention.typeAxe)) {
        errors.typeAxe = 'Le type d\'axe est obligatoire'
      }

      if (intervention.typeAxe === 'ECHANGEUR' && this.isUndefinedOrEmpty(intervention.numeroEchangeur)) {
        errors.numeroEchangeur = 'Le numéro d\'échangeur est obligatoire'
      }


      if(forValidation) {
        if (intervention.heureDebut === '' || intervention.heureDebut === null) {
          errors.heureDebut = 'L\'heure de début est obligatoire'
        }
        if (intervention.heureFin === '' || intervention.heureFin === null) {
          errors.heureFin = 'L\'heure de fin est obligatoire'
        }
      }
      return errors
    },
    reset() {
      this.newIntervention = [{
        "userId": this.currentUser.userId,
        "callDate": new Date(),
        "callTime": '',
        "callOrigin": '',
        "axeInterventionId": '',
        "sens": '',
        "voie": '',
        "heureDebut": '',
        "heureFin": '',
        "ddp": false,
        "presenceChefEquipe": false,
        "presenceRi": false,
        "observation": "",
        "ceiId": (this.userCeis.length === 1) ? this.userCeis[0].id : '',
        "ceiLabel": (this.userCeis.length === 1) ? this.userCeis[0].label : '',
        "localisation": "",
        "typeIntervention": '',
        "precisionNiveau1": '',
        commune: "",
        heureArriveeSite: "",
        heureDepartSite: "",
        moyensHumains: "",
        moyensMateriels: "",
        etatChaussee: "",
        conditionMeteo: "",
        precisionNiveau2: "",
        intervenants: "",
        circonstances: "",
        actionsRealisees: "",
        presenceTiersResponsable: "",
        vehiculesImpliques: "",
        sensListTmp: [],
        inciviliteAgression: false,
      }];

      this.newIntervention[0].callTime = this.formatHour(new Date());
    },
    checkInterventionTimeValidity(intervention) {
      intervention.heureArriveeSite = this.checkTimeValidity(intervention.heureArriveeSite);
      intervention.heureDepartSite = this.checkTimeValidity(intervention.heureDepartSite);
      intervention.callTime = this.checkTimeValidity(intervention.callTime);
      intervention.heureDebut = this.checkTimeValidity(intervention.heureDebut);
      intervention.heureFin = this.checkTimeValidity(intervention.heureFin);
    },
    checkTimeValidity(time) {
      if (!time) return "";
      let timeValues = time.split(":");
      let heures = parseInt(timeValues[0]);
      let minutes = parseInt(timeValues[1]);

      if (heures < 0 || heures > 23) {
        time = "00:" + minutes;
      } else if (minutes < 0 || minutes > 59) {
        time = heures + ":00";
      }
      time = time.replace("NaN", "00");
      return time;
    },
    
    update(intervention) {
      this.getRef().resetMessages();
      intervention.sens = intervention.sensListTmp.join(",");
      let errors = this.getErrors(intervention, false);
      if (Object.keys(errors).length > 0) {
        this.editionErrors[intervention.id] = errors
        this.getRef().error(this.$t("required_fields_empty"));
        return;
      } 
      this.editionErrors[intervention.id] = {}
      
      errors = interventionService.checkFieldsSize(intervention);
      if (Object.keys(errors).length > 0) {
        this.editionErrors[intervention.id] = errors
        this.getRef().error(this.$t("fields_size_error"));
        return;
      }
      this.editionErrors[intervention.id] = {}
      
      this.checkInterventionTimeValidity(intervention);
      interventionService.updateIntervention({intervention: intervention}).then(() => {
        this.submitted = false;
        this.getRef().success(this.$t("intervention.updated"));
      }).catch(error => {
        this.getRef().error(this.$t("unknown_error"));
        console.log(error);
      });
    },
    isEmpty(str) {
      return (!str || 0 === str.length);
    },
    
    creationErrorsInclude(elem) {
     if(!this.creationErrors) return false;
     return Object.keys(this.creationErrors).includes(elem);
    },
    
    editionErrorsInclude(id, elem) {
     if(!this.editionErrors) return false;
     if(!this.editionErrors[id]) return false;
     return !!this.editionErrors[id][elem];
    },
    
    // CREATE
    
    create() {
      let intervention = this.newIntervention[0];
      this.getRef().resetMessages();
      intervention.sens = intervention.sensListTmp.join(",");

      this.creationErrors = {}
      let errors = this.getErrors(intervention, false);
      if (Object.keys(errors).length > 0) {
        this.creationErrors = errors
        this.getRef().error(this.$t("required_fields_empty"));
        return;
      }
      
      this.creationErrors = {}
      errors = interventionService.checkFieldsSize(intervention);
      if (Object.keys(errors).length > 0) {
        this.creationErrors = errors
        this.getRef().error(this.$t("fields_size_error"));
        return;
      } 
      
      this.creationErrors = {}
      let dto = {
        "intervention": intervention,
        "vehiculeImpliqueList": null,
        "ddpList": null
      }
      interventionService.createIntervention(dto).then(() => {
        this.reset();
        this.getRef().success(this.$t("intervention.created"));
        this.reloadInterventions();
      }).catch(error => {
        console.log(error);
      });
    },
    
    // CREATE AND VALIDATE
    
    openCreateAndValidateDialog() {
      this.$refs.dialogCreateAndValidate.show();
    },
    
    createAndValidate() {
      this.getRef().resetMessages();
      let intervention = this.newIntervention[0];
      intervention.sens = intervention.sensListTmp.join(",");

      let errors = this.getErrors(intervention, true);
      if (Object.keys(errors).length > 0) {
        this.creationErrors = errors
        this.getRef().error(this.$t("required_fields_empty"));
        return;
      }
      this.creationErrors = {}
      
      errors = interventionService.checkFieldsSize(intervention);
      if (Object.keys(errors).length > 0) {
        this.creationErrors = errors
        this.getRef().error(this.$t("fields_size_error"));
        return;
      }
      this.creationErrors = {}
      
      let dto = {
        validated: true,
        "intervention": intervention,
        "vehiculeImpliqueList": null,
        "ddpList": null
      }
      interventionService.createIntervention(dto).then(() => {
        this.reset();
        this.getRef().success(this.$t("intervention.createdAndValidated"));
        this.reloadInterventions();
      }).catch(error => {
        console.log(error);
      });
    },
    
    openObservationDialog(data) {
      console.log(data);
      this.current = data;
      this.$refs.dialogObservation.show();
    },
    
    updateTypeIntervention(intervention) {
      this.precision1 = this.hasPrecision1(intervention.typeIntervention);

      if (!this.precision1) {
        intervention.precisionNiveau1 = null;
      } else {
        if (!this.isPrecision1RelatedToTypeIntervention(intervention.typeIntervention, intervention.precisionNiveau1)) {
          intervention.precisionNiveau1 = null;
        }
      }
    },
    
    switchShowOnlyMine() {
      this.showOnlyMine = !this.showOnlyMine;
      this.reloadInterventions(0);
    },
    
    reloadInterventions(timeout = 750) {
      if (this.reloadListTimeout) {
        clearTimeout(this.reloadListTimeout);
      }
      this.reloadListTimeout = setTimeout(() => {
        this.intervLoading = true;
        this.getFilterValues();
        
        let page = this.paginateOptions ? this.paginateOptions.page + 1 : 1;
        let limit = this.paginateOptions ? this.paginateOptions.rows : 1;
        let sort = this.paginateOptions ? this.paginateOptions.sort : null;
        
        //PATCH pour corriger l'erreur de sort sur le status
        if(sort && sort.startsWith("status:")) sort = null;
        
        let params = {
          page: page
          , limit: limit
          , sort: sort
          , searchField: this.searchContent
          , author: this.author
          , callOrigin: this.callOrigin
          , axeInterventionId: this.axeInterventionId
          , sens: this.sens
          , typeIntervention: this.typeIntervention
          , ddp: this.ddp
          , presenceRi: this.presenceRi
          , agerId: this.filterAgerId
          , uerId: this.filterUerId
          , ceiId: this.filterCeiId
          , status: this.filterStatus
          , startDate: this.startDate
          , endDate: this.endDate
          , noInterCei: this.noInterCei
          , noInterDirif: this.noInterDirif
          , mine: this.showOnlyMine
          , inciviliteAgression: this.inciviliteAgression
        };
        
        let p = interventionService.findAllIntervention(params);
        p.then(res => {
          if (null != res.headers['x-pagination-total']) {
            this.totalRecords = parseInt(res.headers['x-pagination-total']);
          }

          res.data.forEach(intervention => {

            if (intervention.sens !== '') {
              intervention.sensListTmp = intervention.sens.split(",")
            } else {
              intervention.sensListTmp = []
            }

            intervention.callDate = new Date(intervention.callDate);

            if (intervention.callTime == null) {
              intervention.callTime = "";
            }

            intervention.agentFullName = intervention.firstName + " " + intervention.lastName;
          });
          this.interventions = res.data;
          this.selectedRows = new Set();
          this.setupEditionErrors();
          this.intervLoading = false;
        });
      
    Promise.all([p]).then(() => {
      this.reloadAgerUerCeiLists().then(() => {
        this.loading = false;
      });
    });
      
      }, timeout);
    },
    
    download() {
      this.isExportDownloading = true;
      let params = {
        author: this.author
        , callOrigin: this.callOrigin
        , axeInterventionId: this.axeInterventionId
        , sens: this.sens
        , typeIntervention: this.typeIntervention
        , ddp: this.ddp
        , presenceRi: this.presenceRi
        , agerId: this.filterAgerId
        , uerId: this.filterUerId
        , ceiId: this.filterCeiId
        , status: this.filterStatus
        , startDate: this.startDate
        , endDate: this.endDate
        , inciviliteAgression: this.inciviliteAgression
      };
      let p = interventionService.downloadInterventionListExcel(params);
      let promises = [p];
      p.catch(() => {
        this.isExportDownloading = false;
        // this.getRef().hideLoader();
        this.getRef().error(this.$t("error_download_synthese"));
      });
      Promise.all(promises).then(() => {
        this.isExportDownloading = false;
      });
    },
    downloadFull() {
      this.isFullExportDownloading = true;
      let params = {
        author: this.author
        , callOrigin: this.callOrigin
        , axeInterventionId: this.axeInterventionId
        , sens: this.sens
        , typeIntervention: this.typeIntervention
        , ddp: this.ddp
        , presenceRi: this.presenceRi
        , agerId: this.filterAgerId
        , uerId: this.filterUerId
        , ceiId: this.filterCeiId
        , status: this.filterStatus
        , startDate: this.startDate
        , endDate: this.endDate
        , inciviliteAgression: this.inciviliteAgression
      };
      let p = interventionService.downloadInterventionListExcelComplet(params);
      let promises = [p];
      p.catch(() => {
        this.isFullExportDownloading = false;
        // this.getRef().hideLoader();
        this.getRef().error(this.$t("error_download_synthese"));
      });
      Promise.all(promises).then(() => {
        this.isFullExportDownloading = false;
      });
    },
    downloadCustom() {
      this.isCustomExportDownloading = true;
      let params = {
        author: this.author
        , callOrigin: this.callOrigin
        , axeInterventionId: this.axeInterventionId
        , sens: this.sens
        , typeIntervention: this.typeIntervention
        , ddp: this.ddp
        , presenceRi: this.presenceRi
        , agerId: this.filterAgerId
        , uerId: this.filterUerId
        , ceiId: this.filterCeiId
        , status: this.filterStatus
        , startDate: this.startDate
        , endDate: this.endDate
        , inciviliteAgression: this.inciviliteAgression
      };
      let p = interventionService.downloadInterventionListExcelCustom(params);
      let promises = [p];
      p.catch(() => {
        this.isCustomExportDownloading = false;
        // this.getRef().hideLoader();
        this.getRef().error(this.$t("error_download_synthese"));
      });
      Promise.all(promises).then(() => {
        this.isCustomExportDownloading = false;
      });
    },
    paginate(event) {
      this.paginateOptions.page = null != event.page ? event.page : 0;
      this.paginateOptions.rows = null != event.rows ? event.rows : 10;
      if (null != event.sortField) {
        let sortPart = []
        sortPart.push(event.sortField);
        sortPart.push(event.sortOrder === 1 ? "ASC" : "DESC")

        if (event.sortField === "call_date") {

          this.paginateOptions.sort = sortPart.join(":");

          sortPart = [];
          sortPart.push("call_time");
          sortPart.push(event.sortOrder === 1 ? "ASC" : "DESC")
          this.paginateOptions.sort = this.paginateOptions.sort + "," + sortPart.join(":");
        } else {
          this.paginateOptions.sort = sortPart.join(":");
        }
      } else {
        this.paginateOptions.sort = null;
      }

      this.userParamsIntervention.paginateOptions = this.paginateOptions;
      this.$store.dispatch("setUserParams", this.userParams);
      this.reloadInterventions();
    },
    displayLightInterventionBlock() {
      this.displayCreateLightIntervention = true;
    },
    deleteIntervention() {
      interventionService.deleteIntervention(this.current.id).then(() => {
        this.reloadInterventions(0);
        this.getRef().success(this.$t("intervention.deleted"));
      }).catch(() => {
        this.getRef().error(this.$t("intervention.deleted_failed"));
      })
    },
    openDeleteDialog(data) {
      this.current = data;
      this.$refs.dialogDelete.show();
    },
    onSelectAllChange() {
      this.selectedRows = new Set();
      if (this.selectAll) {
        this.interventions.forEach(intervention => {
          intervention.selected = true;
          this.selectedRows.add(intervention);
        });
      } else {
        this.interventions.forEach(intervention => {
          intervention.selected = false;
        });
      }
    },
    onSelectedChange(data) {
      if (!data.selected) {
        if (this.selectAll) {
          this.selectAll = false;
        }
        this.selectedRows.delete(data);
      } else {
        this.selectedRows.add(data);
      }
    },
    deleteSelectedRows() {
      if (this.selectedRows.size === 0) {
        this.getRef().error(this.$t("intervention.no_intervention_selected"));
        return;
      }
      if (this.selectedRows.length > 50) {
        this.getRef().error(this.$t("intervention.too_many_interventions_selected"));
        return;
      }
      interventionService.deleteList(Array.from(this.selectedRows)).then(() => {
        this.reloadInterventions();
        if (this.selectedRows.size > 1) {
          this.getRef().success(this.$t("intervention.interventions_deleted"));
        } else {
          this.getRef().success(this.$t("intervention.deleted"));
        }
        if (this.selectAll) {
          this.selectAll = false;
          this.selectedRows = new Set();
        }
      }).catch(() => {
        if (this.selectedRows.size > 1)
          this.getRef().error(this.$t("intervention.interventions_not_deleted"));
        else
          this.getRef().error(this.$t("intervention.deleted_failed"));
      })
    },
    openSettingsDialog() {
      userSettingsService.getInterventionSettings(this.currentUser.userId).then(data => {
        this.userSettings = data;
        
        // Sort settings by ordre
        this.userSettings.settingsValue = this.sortDict(this.userSettings.settingsValue, "ordre");
        let value = this.userSettings.settingsValue;

        if (value["callTime"].value 
        && value["callDate"].value 
        && value["callOrigin"].value 
        && value["observation"].value) {
          this.origineAppel = true;
        } else {
          this.origineAppel = false;
        }

        if (value["agents"].value 
        && value["axe"].value 
        && value["sens"].value 
        && value["voie"].value 
        && value["commune"].value 
        && value["heureArriveeSite"].value 
        && value["heureDepartSite"].value 
        && value["localisation"].value 
        && value["noBretelle"].value 
        && value["noAutoroute"].value) {
          this.lieuIntervention = true;
        } else {
          this.lieuIntervention = false;
        }

        if (value["heureDebut"].value 
        && value["heureFin"].value 
        && value["circonstances"].value) {
          this.intervention = true;
        } else {
          this.intervention = false;
        }

        if (value["typeIntervention"].value 
        && value["precisionNiveau1"].value 
        && value["precisionNiveau2"].value 
        && value["etatChaussee"].value 
        && value["conditionsMeteo"].value 
        && value["intervenants"].value 
        && value["actionsRealisees"].value 
        && value["presenceTiersResponsable"].value) {
          this.environnement = true;
        } else {
          this.environnement = false;
        }

        this.$refs.settingsDialog.show();
      });
    },
    openTableSettingsDialog() {
      userSettingsService.getTableInterventionSettings(this.currentUser.userId).then(data => {
        this.tableSettings = data;

        // Sort settings by ordre
        this.tableSettings.settingsValue = this.sortDict(this.tableSettings.settingsValue, "ordre");
        this.tmpTableSettings = JSON.parse(JSON.stringify(this.tableSettings));
        this.$refs.tableSettingsDialog.show();
      });
    },
    sortDict(dict, field) {
      let keyValues = []

      for (let key in dict) {
        keyValues.push([key, dict[key]])
      }
      keyValues = keyValues.sort((a, b) => a[1][field] - b[1][field])
      let newDict = {}

      for (let key in keyValues) {
        newDict[keyValues[key][0]] = keyValues[key][1]
      }
      return newDict;
    },
    updateTableSettings() {
      this.$refs.tableSettingsDialog.hide();
      userSettingsService.updateSettings(this.tmpTableSettings).then(() => {
        this.getRef().success(this.$t("settings_saved"));
        this.tableSettings = this.tmpTableSettings;
      }).catch(() => {
        this.getRef().error(this.$t("settings_not_saved"));
      })
    },
    updateSettings() {
      this.$refs.settingsDialog.hide();
      userSettingsService.updateSettings(this.userSettings).then(() => {
        this.getRef().success(this.$t("settings_saved"));
      }).catch(() => {
        this.getRef().error(this.$t("settings_not_saved"));
      })
    },
    resetUserSettings(value) {
      for (let object in this.userSettings.settingsValue) {
        this.userSettings.settingsValue[object].value = value;
      }
    },
    resetTableSettings(value) {
      for (let object in this.tmpTableSettings.settingsValue) {
        this.tmpTableSettings.settingsValue[object].value = value;
      }
    },
    isAxeInterventionBretelle(axeInterventionId) {
      return !this.isEmpty(axeInterventionId) && this.axeInterventionList.find(axe => axe.id === axeInterventionId)?.technicalName === "BRETELLE";
    },
    getFilterValues() {
      this.searchContent = this.userParamsIntervention?.searchValue;
      this.author = this.userParamsIntervention?.author;
      this.callOrigin = this.userParamsIntervention?.callOrigin;
      this.axeInterventionId = this.userParamsIntervention?.axeInterventionId;
      this.sens = this.userParamsIntervention?.sens;
      this.typeIntervention = this.userParamsIntervention?.typeIntervention;
      this.ddp = this.userParamsIntervention?.ddp;
      this.presenceRi = this.userParamsIntervention?.presenceRi;
      this.filterAgerId = this.userParamsIntervention?.filterAgerId;
      this.filterUerId = this.userParamsIntervention?.filterUerId;
      this.filterCeiId = this.userParamsIntervention?.filterCeiId;
      this.filterStatus = this.userParamsIntervention?.filterStatus;
      this.startDate = this.userParamsIntervention?.startDate ? new Date(this.userParamsIntervention?.startDate) : null;
      this.endDate = this.userParamsIntervention?.endDate ? new Date(this.userParamsIntervention?.endDate) : null;
      this.noInterCei = this.userParamsIntervention?.noInterCei;
      this.inciviliteAgression = this.userParamsIntervention?.inciviliteAgression;
    },
    resetFilter() {
      this.$store.dispatch("resetInterventionUserParams");
      this.getFilterValues();
      this.reloadInterventions();
    },
    clearDateRange() {
      this.startDate = null;
      this.endDate = null;
      this.userParamsIntervention.startDate = null;
      this.userParamsIntervention.endDate = null;
      this.$store.dispatch("setUserParams", this.userParams);
      this.reloadInterventions();
    },
    toggleOrigineAppel() {
      let value = this.userSettings.settingsValue;
      let v = !this.origineAppel;
      
      this.origineAppel = v;
      value["callTime"].value = v;
      value["callDate"].value = v;
      value["callOrigin"].value = v;
      value["observation"].value = v;
    },
    toggleLieuIntervention() {
      let value = this.userSettings.settingsValue;
      let v = !this.lieuIntervention;
      
      this.lieuIntervention = v;
      value["agents"].value = v;
      value["axe"].value = v;
      value["sens"].value = v;
      value["voie"].value = v;
      value["commune"].value = v;
      value["heureArriveeSite"].value = v;
      value["heureDepartSite"].value = v;
      value["localisation"].value = v;
      value["noBretelle"].value = v;
      value["noAutoroute"].value = v;
    },
    toggleIntervention() {
      let value = this.userSettings.settingsValue;
      let v = !this.intervention;

      this.intervention = v;
      value["heureDebut"].value = v;
      value["heureFin"].value = v;
      value["circonstances"].value = v;
    },
    toggleEnvironnement() {
      let value = this.userSettings.settingsValue;
      let v = !this.environnement;
      
      value["typeIntervention"].value = v;
      value["precisionNiveau1"].value = v;
      value["precisionNiveau2"].value = v;
      value["etatChaussee"].value = v;
      value["conditionsMeteo"].value = v;
      value["intervenants"].value = v;
      value["actionsRealisees"].value = v;
      value["presenceTiersResponsable"].value = v;
    },
    displayColumnFor(id) {
      if(!this.tableSettings) return true;
      if(!this.tableSettings.settingsValue[id]) return true;
      return this.tableSettings.settingsValue[id].value;
    },
    openHelpDialog() {
      this.$refs.helpDialog.show();
    },
    
    // CAN
    
    canUpdate(data) {
      return data.canUpdate;
     },
    canDelete(data) {
      return data.canDelete;
    },
    getSelectedAxe(intervention) {
      if (!intervention.axeInterventionId) return null;
      return this.axeInterventionList.find(axe => axe.id === intervention.axeInterventionId);
    },
  },
  
  computed: {
   labelShowOnlyMine() {
     return this.showOnlyMine ? this.$t("see_all") : this.$t("see_mine_f");
   },
   
   displayableInterventions() {
     if(this.showOnlyMine) return this.interventions.filter(o=>o.mine);
     return this.interventions;
   },
   
    // CAN
   
    canCreate() {
      return this.canCreateIntervention();
    },
    canDownload() {
      return this.canDownloadIntervention();
    },
    canDeleteSelectedRows() {
      return this.canDeleteInterventions(this.selectedRows);
    },
    
    userParams() {
      return this.$store.state.userParams;
    },
    userParamsIntervention() {
      return this.userParams?.intervention;
    },
    selectedAxe() {
      if (this.newIntervention.length === 0) return null;
      return this.axeInterventionList.find(axe => axe.id === this.newIntervention[0].axeInterventionId);
    }
  },
  watch: {
    searchContent: function (newVal) {
      if (this.intervLoading) return;
      this.userParamsIntervention.searchValue = newVal;
      this.$store.dispatch("setUserParams", this.userParams);
      this.reloadInterventions();
    },
    author() {
      if (this.intervLoading) return;
      this.userParamsIntervention.author = this.author;
      this.$store.dispatch("setUserParams", this.userParams);
      this.reloadInterventions();
    },
    callOrigin() {
      if (this.intervLoading) return;
      this.userParamsIntervention.callOrigin = this.callOrigin;
      this.$store.dispatch("setUserParams", this.userParams);
      this.reloadInterventions();
    },
    axeInterventionId() {
      if (this.intervLoading) return;
      this.userParamsIntervention.axeInterventionId = this.axeInterventionId;
      this.$store.dispatch("setUserParams", this.userParams);
      this.reloadInterventions();
    },
    sens() {
      if (this.intervLoading) return;
      this.userParamsIntervention.sens = this.sens;
      this.$store.dispatch("setUserParams", this.userParams);
      this.reloadInterventions();
    },
    typeIntervention() {
      if (this.intervLoading) return;
      this.userParamsIntervention.typeIntervention = this.typeIntervention;
      this.$store.dispatch("setUserParams", this.userParams);
      this.reloadInterventions();
    },
    ddp() {
      if (this.intervLoading) return;
      this.userParamsIntervention.ddp = this.ddp;
      this.$store.dispatch("setUserParams", this.userParams);
      this.reloadInterventions();
    },
    presenceRi() {
      if (this.intervLoading) return;
      this.userParamsIntervention.presenceRi = this.presenceRi;
      this.$store.dispatch("setUserParams", this.userParams);
      this.reloadInterventions();
    },
    filterAgerId() {
      if (this.intervLoading) return;
      this.userParamsIntervention.filterAgerId = this.filterAgerId;
      this.$store.dispatch("setUserParams", this.userParams);
      this.reloadInterventions();
    },
    filterUerId() {
      if (this.intervLoading) return;
      this.userParamsIntervention.filterUerId = this.filterUerId;
      this.$store.dispatch("setUserParams", this.userParams);
      this.reloadInterventions();
    },
    filterCeiId() {
      if (this.intervLoading) return;
      this.userParamsIntervention.filterCeiId = this.filterCeiId;
      this.$store.dispatch("setUserParams", this.userParams);
      this.reloadInterventions();
    },
    filterStatus() {
      if (this.intervLoading) return;
      this.userParamsIntervention.filterStatus = this.filterStatus;
      this.$store.dispatch("setUserParams", this.userParams);
      this.reloadInterventions();
    },
    startDate() {
      if (this.intervLoading) return;
      this.userParamsIntervention.startDate = this.startDate;
      this.$store.dispatch("setUserParams", this.userParams);
      this.reloadInterventions();
    },
    endDate() {
      if (this.intervLoading) return;
      this.userParamsIntervention.endDate = this.endDate;
      this.$store.dispatch("setUserParams", this.userParams);
      this.reloadInterventions();
    },
    noInterCei() {
      if (this.intervLoading) return;
      this.userParamsIntervention.noInterCei = this.noInterCei;
      this.$store.dispatch("setUserParams", this.userParams);
      this.reloadInterventions();
    },
    noInterDirif() {
      if (this.intervLoading) return;
      this.userParamsIntervention.noInterDirif = this.noInterDirif;
      this.$store.dispatch("setUserParams", this.userParams);
      this.reloadInterventions();
    },
    inciviliteAgression() {
      if (this.intervLoading) return;
      this.userParamsIntervention.inciviliteAgression = this.inciviliteAgression;
      this.$store.dispatch("setUserParams", this.userParams);
      this.reloadInterventions();
    },
    "userSettings.settingsValue": {
      handler() {
        let value = this.userSettings.settingsValue;
        
        this.origineAppel = value["callTime"] 
        && value["callDate"].value 
        && value["callOrigin"].value 
        && value["observation"].value;
        
        this.lieuIntervention = value["agents"].value 
        && value["axe"].value 
        && value["sens"].value 
        && value["voie"].value 
        && value["commune"].value 
        && value["heureArriveeSite"].value 
        && value["heureDepartSite"].value 
        && value["localisation"].value 
        && value["noBretelle"].value 
        && value["noAutoroute"].value;
        
        this.intervention = value["heureDebut"].value 
        && value["heureFin"].value 
        && value["circonstances"].value;
        
        this.environnement = value["typeIntervention"].value 
        && value["precisionNiveau1"].value 
        && value["precisionNiveau2"].value 
        && value["etatChaussee"].value 
        && value["conditionsMeteo"].value 
        && value["intervenants"].value 
        && value["actionsRealisees"].value 
        && value["presenceTiersResponsable"].value;
      },
      deep: true
    },
  }
}
</script>

<template>
  <template v-if="loading">
    <ProgressSpinner style="position: absolute; top: 50%; left: 50%;"/>
  </template>
  <template v-else>
    <AkFormList :display-go-back="false" :ref="ref" :title="$t('intervention.title')">
      <template v-slot:action>
        <div class="action-bar">
          <span class="p-input-icon-left search-bar-desktop">
            <i class="pi pi-search"/>
            <InputText v-model="searchContent" @keyup="reloadInterventions()" :placeholder="$t('search_here')"/>
          </span>
          <button @click="openTableSettingsDialog()" class="btn btn-inverse-dark">
            <i class="fe fe-settings pr-1"/>
            {{ $t('intervention_list.settings_intervention_table') }}
          </button>
          <button v-if="canDownload" @click="openSettingsDialog()" class="btn btn-inverse-dark">
            <i class="fe fe-settings pr-1"/>
            {{ $t('intervention_list.settings_custom_excel') }}
          </button>
          
          <button 
          v-if="canDownload" 
          @click="downloadCustom()" 
          class="btn btn-inverse-primary"
                  :disabled="isCustomExportDownloading">
            <i class="fe fe-download pr-1" v-if="!isCustomExportDownloading"/>
            <i class="pi pi-spin pi-spinner mr-1" v-if="isCustomExportDownloading"></i>
            {{ $t('intervention_list.download_custom_excel') }}
          </button>
          
          <button 
          v-if="canDownload" 
          @click="download()" 
          class="btn btn-inverse-primary"
                  :disabled="isExportDownloading">
            <i class="fe fe-download pr-1" v-if="!isExportDownloading"/>
            <i class="pi pi-spin pi-spinner mr-1" v-if="isExportDownloading"></i>
            {{ $t('intervention_list.download_excel') }}
          </button>
          
          <button 
          v-if="canDownload" 
          @click="downloadFull()" 
          class="btn btn-inverse-primary"
                  :disabled="isFullExportDownloading">
            <i class="fe fe-download pr-1" v-if="!isFullExportDownloading"/>
            <i class="pi pi-spin pi-spinner mr-1" v-if="isFullExportDownloading"></i>
            {{ $t('intervention_list.download_excel_full') }}
          </button>
        </div>
      </template>
      
      <template v-slot:list v-if="canCreate">
        <div class="row">
          <div class="col-lg-12">
            <div class="card card-statistics">
              <div class="card-body">
                <div class="action-card">
                  <div>
                    <button @click="displayLightInterventionBlock()"
                            class="btn btn-inverse-primary" :disabled="isFullExportDownloading">
                      <i class="fe fe-plus pr-1"/>
                      {{ $t('intervention_list.add_light_intervention') }}
                    </button>
                    <RouterLink :to="{ name: 'interventionCreate' }" class="btn btn-inverse-primary">
                      <i class="fe fe fe-plus pr-1"/>{{ $t('intervention_list.add_full_intervention') }}
                    </RouterLink>
                  </div>
                  <Button
                      v-if="canDeleteSelectedRows"
                      class="btn btn-inverse-danger"
                      @click="deleteSelectedRows()">
                    <i class="fe fe-trash pr-1"/>
                    {{ $t('intervention.delete_selected_interventions') }}
                  </Button>
                </div>

                <div class="table-responsive mt-1" v-if="displayCreateLightIntervention">
                  <DataTable
                      :always-show-paginator=false :paginator=false :rows=1
                      v-if="true"
                      :loading="loading"
                      :value="this.newIntervention"
                      class="table"
                      :sortOrder=-1
                      removableSort
                      responsiveLayout="scroll"
                      stripedRows
                      dataKey="id">
                    <template #empty>
                      {{ $t("list_empty") }}
                    </template>
                    <Column :header="$t('cei_label') + '*'">
                      <template #body="slotProps">
                        <AkDropdown
                            :filter="true"
                            v-if="userCeis.length>1"
                            label=""
                            v-model="slotProps.data.ceiId"
                            :options=userCeis
                            option-value="id"
                            option-label="label"
                            :class-name="(this.creationErrorsInclude('ceiId') ? 'datatable-validation-error' : '')"/>
                        <AkInputText
                            v-else
                            disabled
                            :label="$t('cei_label')"
                            v-text="slotProps.data.ceiLabel"
                            class-name=""/>
                      </template>
                    </Column>
                    <Column field="call_date_hour" :header="$t('intervention.call_date_hour')">
                      <template #body="slotProps">
                        <AkDateTime
                            v-model="slotProps.data.callDate"
                            :submitted="submitted"
                            :showTime="false"
                            :class-name="''"
                            :max-date="new Date()"
                            placeholder="dd/mm/yyyy"/>
                        <AkInputMask
                            v-model="slotProps.data.callTime"
                            mask="99:99"
                            :class-name="''"
                            :onchange="this.checkInterventionTimeValidity(slotProps.data)"
                            placeholder="__:__"/>
                      </template>
                    </Column>
                    <Column field="callOrigin" :header="$t('intervention.call_origin') + '*'">
                      <template #body="slotProps">
                        <AkDropdown
                            :filter="true"
                            label=""
                            v-model="slotProps.data.callOrigin"
                            :options=origineAppelConst
                            option-value="value"
                            option-label="label"
                            :class-name="(this.creationErrorsInclude('callOrigin') ? 'datatable-validation-error' : '')"/>
                        <AkInputText v-if="'AUTRE' === slotProps.data.callOrigin"
                                     label=""
                                     v-model="slotProps.data.otherCallOrigin"
                                     :placeholder="$t('intervention.other_call_origin')"
                                     :class-name="''"
                        />
                      </template>
                    </Column>
                    <Column field="axe_sens" :header="$t('intervention.axe') + '*/' + $t('intervention.sens')">
                      <template #body="slotProps">
                        <AkDropdown :placeholder="$t('intervention.type_axe')"
                                    :filter="true"
                                    v-model="slotProps.data.typeAxe"
                                    :options=getTypeAxeInterventionConst()
                                    option-value="value"
                                    option-label="label"
                                    :show-required-symbol="false"
                                    show-clear
                                    :class-name="(this.creationErrorsInclude('typeAxe') ? 'datatable-validation-error' : '')"/>

                        <AkDropdown :placeholder="$t('intervention.axe')"
                                    :filter="true"
                                    v-model="slotProps.data.axeInterventionId"
                                    v-if="slotProps.data.typeAxe"
                                    :options=axeInterventionList
                                    option-value="id"
                                    option-label="libelle"
                                    :show-required-symbol="false"
                                    show-clear
                                    :class-name="(this.creationErrorsInclude('axeInterventionId') ? 'datatable-validation-error' : '')"/>

                        <template v-if="slotProps.data.axeInterventionId && slotProps.data.typeAxe !== 'SECTION_COURANTE'">
                          <AkInputText :placeholder="$t('intervention.no_echangeur')"
                                       v-model="slotProps.data.numeroEchangeur"
                                       v-if="slotProps.data.typeAxe === 'ECHANGEUR'"
                                       :class-name="(this.creationErrorsInclude('numeroEchangeur') ? 'datatable-validation-error' : '')"/>


                          <AkInputText :placeholder="$t('intervention.no_bretelle')"
                                       v-model="slotProps.data.numeroBretelle"
                                       class-name=""/>

                          <AkInputText :placeholder="$t('intervention.direction')"
                                       v-model="slotProps.data.direction"
                                       class-name=""/>
                          <!--Si ce n'est pas une autoroute c'est affiché-->
                          <AkInputText :placeholder="$t('intervention.nom_lieu')"
                                       v-if="selectedAxe && selectedAxe.techType !== 'A' && slotProps.data.typeAxe === 'ECHANGEUR'"
                                       v-model="slotProps.data.nomLieu"
                                       class-name=""/>
                        </template>

                        <AkDropdownMultiple
                            label=""
                            :placeholder="$t('intervention.sens')"
                            v-model="slotProps.data.sensListTmp"
                            :options=sensConst
                            option-value="value"
                            option-label="label"
                            :filter="true"
                            :class-name="(this.creationErrorsInclude('sens') ? 'datatable-validation-error' : '')"/>
                      </template>
                    </Column>
                    <Column field="localisation">
                      <template #header>
                        {{ $t('intervention.pr') }} <i class="fa fa-info-circle tooltip-centered"
                                                       v-tooltip="$t('intervention.pr_format_tooltip')"/>
                        *
                        / {{ $t('intervention.voie') }}
                      </template>
                      <template #body="slotProps">
                        <AkInputText
                            :placeholder="$t('intervention.pr')"
                            label=""
                            v-model="slotProps.data.localisation"
                            :regexp="prValidatorRegexpFormat"
                            :class-name="(this.creationErrorsInclude('localisation') ? 'datatable-validation-error' : '')"/>
                        <AkInputText
                            :placeholder="$t('intervention.voie')"
                            label=""
                            v-model="slotProps.data.voie"
                            :class-name="(this.creationErrorsInclude('voie') ? 'datatable-validation-error' : '')"/>
                      </template>
                    </Column>
                    <Column field="heure_arrivee_depart" :header="$t('intervention.heure_arrivee_depart')">
                      <template #body="slotProps">
                        <AkInputMask
                            v-model="slotProps.data.heureArriveeSite"
                            :class-name="(this.creationErrorsInclude('heureArriveeSite') ? 'datatable-validation-error' : '')"
                            mask="99:99"
                            :onchange="this.checkInterventionTimeValidity(slotProps.data)"
                            placeholder="__:__"/>
                        <AkInputMask
                            v-model="slotProps.data.heureDepartSite"
                            :class-name="(this.creationErrorsInclude('heureDepartSite') ? 'datatable-validation-error' : '')"
                            mask="99:99"
                            :onchange="this.checkInterventionTimeValidity(slotProps.data)"
                            placeholder="__:__"/>
                      </template>
                    </Column>
                    <Column field="heure_debut_fin" :header="$t('intervention.heure_debut_fin_required')">
                      <template #body="slotProps">
                        <AkInputMask
                            v-model="slotProps.data.heureDebut"
                            :class-name="(this.creationErrorsInclude('heureDebut') ? 'datatable-validation-error' : '')"
                            mask="99:99"
                            :onchange="this.checkInterventionTimeValidity(slotProps.data)"
                            placeholder="__:__"/>
                        <AkInputMask
                            v-model="slotProps.data.heureFin"
                            :class-name="(this.creationErrorsInclude('heureFin') ? 'datatable-validation-error' : '')"
                            mask="99:99"
                            :onchange="this.checkInterventionTimeValidity(slotProps.data)"
                            placeholder="__:__"/>
                      </template>
                    </Column>
                    <Column field="type_intervention" :header="$t('intervention.type_intervention')">
                      <template #body="slotProps">
                        <AkDropdown
                            :filter="true"
                            label=""
                            v-model="slotProps.data.typeIntervention"
                            :options=typeInterventionConst
                            option-value="value"
                            option-label="label"
                            :class-name="(this.creationErrorsInclude('typeIntervention') ? 'datatable-validation-error' : '')"
                            :(onBlur)="updateTypeIntervention(slotProps.data)"/>
                        <AkDropdown
                            :filter="true"
                            label=""
                            v-if="precision1"
                            v-model="slotProps.data.precisionNiveau1"
                            :options="this.getPrecision1Const(slotProps.data.typeIntervention)"
                            option-value="value"
                            option-label="label"
                            class-name=""/>
                        <AkInputText v-if="'AUTRE' === slotProps.data.typeIntervention"
                                     label=""
                                     v-model="slotProps.data.otherTypeIntervention"
                                     :class-name="''"
                        />
                      </template>
                    </Column>
                    <Column field="ddp" :header="$t('ddp.title_short')">
                      <template #body="slotProps">
                        <AkCheckbox
                            v-model="slotProps.data.ddp"
                            style="margin-bottom: 0 !important;"
                            class-name="" label=""/>
                      </template>
                    </Column>
                    <Column field="ddp" :header="$t('incivilite_agression.title')">
                      <template #body="slotProps">
                        <AkCheckbox
                            v-model="slotProps.data.inciviliteAgression"
                            style="margin-bottom: 0 !important;"
                            class-name="" label=""/>
                      </template>
                    </Column>
                    <Column field="ri" :header="$t('intervention.ri')">
                      <template #body="slotProps">
                        <AkCheckbox
                            v-model="slotProps.data.presenceRi"
                            style="margin-bottom: 0 !important;"
                            class-name="" label=""/>
                      </template>
                    </Column>
                    <template #footer>
                      <div class="d-flex align-items-center justify-content-between">
                        <AkInputTextArea
                            style="width: 90% !important;"
                            :label="$t('intervention.observation')"
                            :rows=3
                            v-model="this.newIntervention[0].observation"
                            class-name=""/>
                            
                        <div>
                           <button
                               style="height: 20px;"
                               class="btn btn-xs btn-inverse-primary m-1"
                               @click="create()">
                             <i class="fe fe-save"/>
                             Enregistrer le brouillon
                           </button>
                           <button
                               style="height: 20px;"
                               class="btn btn-xs btn-inverse-primary m-1"
                               @click="openCreateAndValidateDialog()">
                             <i class="fe fe-check"/>
                             Enregistrer et valider
                           </button>
                        </div>
                      </div>
                    </template>
                  </DataTable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      
    </AkFormList>
    <AkFormList :display-go-back="false">
      <template v-slot:list>
        <div class="row">
          <div class="col-lg-12">
            <div class="card card-statistics">
              <div class="card-body">
                <div class="action-card">
                  <div></div>
                  <div>
                    <Button
                      v-text="this.labelShowOnlyMine"
                      class="btn btn-inverse-primary"
                      @click="switchShowOnlyMine()"/>
                    
                    <button @click="resetFilter()" class="btn btn-inverse-primary">{{
                        $t('reset_filter')
                      }}
                    </button>
                      
                    <span>
                      <button @click="openHelpDialog()" class="btn btn-inverse-dark">
                        <i class="fe fe-info" />
                      </button>
                    </span>
                  </div>
                </div>
                <div class="mt-3">
                  <div class="filters">
                    <div class="date">
                      <AkCalendar :label="$t('date_range') + ' du'" :max-date="endDate" v-model="startDate"
                                  class-name="" selection-mode="single" style="padding-left: 0 !important;"/>
                      <AkCalendar :label="'Au'" v-model="endDate" :min-date="startDate" selection-mode="single"
                                  class-name="" style="padding-left: 0 !important;"/>
                      <i v-if="this.startDate || this.endDate" class="pi pi-times"
                         style="padding-top: 15px; cursor: pointer; color: #6c757d;" @click="clearDateRange()"/>
                    </div>
                  </div>

                  <div class="filters">
                    <AkInputText v-model="noInterDirif"
                                 :label="$t('intervention.no_intervention_dirif')"
                                 class-name=""/>
                    <AkInputText v-model="noInterCei"
                                 :label="$t('intervention.no_intervention_cei')"
                                 class-name=""/>
                    <AkInputText v-model="author"
                                 :label="$t('author')"
                                 class-name=""/>
                    <AkDropdown :options="agerList"
                                v-model="filterAgerId"
                                :label="$t('intervention.ager')"
                                option-value="id"
                                option-label="label"
                                class-name=""
                                :show-clear=true />
                    <AkDropdown :options="uerList"
                                v-model="filterUerId"
                                :label="$t('intervention.uer')"
                                option-value="id"
                                option-label="label"
                                class-name=""
                                :show-clear=true />
                    <AkDropdown :options="ceiList"
                                v-model="filterCeiId"
                                :label="$t('intervention.cei')"
                                option-value="id"
                                option-label="label"
                                class-name=""
                                :show-clear=true />
                    <AkDropdown :options="statusList"
                                v-model="filterStatus"
                                :label="$t('intervention.status')"
                                option-value="value"
                                option-label="label"
                                class-name=""
                                :show-clear=true />
                  </div>

                  <div class="filters">
                    <AkDropdown :options="origineAppelConst"
                                v-model="callOrigin"
                                :label="$t('intervention.call_origin')"
                                option-value="value"
                                option-label="label"
                                class-name=""
                                :show-clear=true />
                    <AkDropdown :options="axeInterventionList"
                                v-model="axeInterventionId"
                                :label="$t('intervention.axe')"
                                option-value="id"
                                class-name=""
                                option-label="libelle"
                                :show-clear=true />
                    <AkDropdown :options="sensConst"
                                v-model="sens"
                                :label="$t('intervention.sens')"
                                option-value="value"
                                option-label="label"
                                class-name=""
                                :show-clear=true />
                    <AkDropdown :options="typeInterventionConst"
                                v-model="typeIntervention"
                                class-name=""
                                :label="$t('intervention.type_intervention')"
                                option-value="value"
                                option-label="label"/>
                    <AkYesNoButton :label="$t('intervention.presence_ri')"
                                   class-name="" v-model="presenceRi" :options="yesNoEmpty"/>
                    <AkYesNoButton :label="$t('ddp.title_short')"
                                   class-name="" v-model="ddp" :options="yesNoEmpty"/>
                    <AkYesNoButton :label="$t('incivilite_agression.title')"
                                   class-name="" v-model="inciviliteAgression" :options="yesNoEmpty"/>
                  </div>
                </div>
              </div>
              <div class="table-responsive" id="interventionListDatatable">


                <DataTable :always-show-paginator=false :rows=10
                           lazy paginator
                           :totalRecords="totalRecords"
                           @page="paginate($event)"
                           @sort="paginate($event)"
                           v-if="true"
                           :loading="intervLoading"
                           :rowsPerPageOptions="[10,20,50]"
                           :value="displayableInterventions"
                           class="table stickyTable"
                           sortField="call_date"
                           :sortOrder=-1
                           scrollable
                           scrollHeight="600px"
                           responsive-layout="scroll"
                           paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                           removableSort stateStorage="session" stateKey="dt-intervention-list"
                           stripedRows>
                  <template #empty>
                    {{ $t("list_empty") }}
                  </template>
                  <Column bodyStyle="vertical-align: middle;"
                          headerStyle="width: 200px;">
                    <template #body="slotProps">
                      <button v-if="canUpdate(slotProps.data)"
                              v-tooltip="'Modifier l\'intervention'"
                              class="btn btn-xs btn-inverse-primary m-1"
                              @click="update(slotProps.data)">
                        <i class="fe fe-save"/>
                      </button>
                      <RouterLink
                          :to="{name: 'interventionDetails', params: {id: slotProps.data.id}}"
                          class="btn btn-xs btn-inverse-primary m-1">
                        <i class="fe fe-eye"/>
                      </RouterLink>
                      <button v-if="canDelete(slotProps.data)" 
                              v-tooltip="'Supprimer l\'intervention'"
                              class="btn btn-xs btn-inverse-danger m-1"
                              @click="openDeleteDialog(slotProps.data)">
                        <i class="fe fe-trash"/>
                      </button>

                    </template>
                  </Column>
                  <template v-if="canDeleteSelectedRows">
                    <Column headerStyle="width: 3rem">
                      <template #header>
                        <AkCheckbox v-model="selectAll" @change="onSelectAllChange"/>
                      </template>
                      <template #body="slotProps">
                        <AkCheckbox v-if="canDelete(slotProps.data)" v-model="slotProps.data.selected" @change="onSelectedChange(slotProps.data)"/>
                      </template>
                    </Column>
                  </template>
                  <template v-if="this.displayColumnFor('noInterventionDirif')">
                    <Column sortField="no_intervention_dirif" field="noInterventionDirif"
                            :header="$t('intervention.no_intervention_dirif')" :sortable="true">
                      <template #body="slotProps">
                        {{ slotProps.data.noInterventionDirif }}
                      </template>
                    </Column>
                  </template>
                  <template v-if="this.displayColumnFor('noInterventionCei')">
                    <Column sortField="no_intervention_cei" field="noInterventionCei"
                            :header="$t('intervention.no_intervention_cei')" :sortable="true">
                      <template #body="slotProps">
                        {{ slotProps.data.noInterventionCei }}
                      </template>
                    </Column>
                  </template>
                  <template v-if="this.displayColumnFor('author')">
                    <Column field="fullName" sort-field="j_full_name" :header="$t('author')" :sortable="true">
                      <template #body="slotProps">
                        {{ slotProps.data.fullName }}
                      </template>
                    </Column>
                  </template>
                  <template
                      v-if="this.displayColumnFor('ager')">
                    <Column field="ager_label" :header="$t('intervention.ager')"
                            :sortable="false">
                      <template #body="slotProps">
                        {{ slotProps.data.agerLabel }}
                      </template>
                    </Column>
                  </template>
                  <template
                      v-if="this.displayColumnFor('uer')">
                    <Column field="uer_label" :header="$t('intervention.uer')"
                            :sortable="false">
                      <template #body="slotProps">
                        {{ slotProps.data.uerLabel }}
                      </template>
                    </Column>
                  </template>
                  <template
                      v-if="this.displayColumnFor('cei')">
                    <Column sortField="j_cei_label" field="cei_label" :header="$t('intervention.cei')"
                            :sortable="true">
                      <template #body="slotProps">
                        {{ slotProps.data.ceiLabel }}
                      </template>
                    </Column>
                  </template>
                  <template v-if="this.displayColumnFor('callDate')">
                    <Column sortField="call_date" field="callDate" :header="$t('intervention.call_date_hour')"
                            :sortable="true">
                      <template #body="slotProps">
                        <AkDateTime v-model="slotProps.data.callDate"
                                    :showTime="false"
                                    placeholder="dd/mm/yyyy"
                                    :max-date="new Date()"
                                    :disabled="!canUpdate(slotProps.data)"
                                    :class-name="(this.editionErrorsInclude(slotProps.data.id, 'callDate') ? 'datatable-validation-error' : '')"/>
                        <AkInputMask v-model="slotProps.data.callTime"
                                     :class-name="(this.editionErrorsInclude(slotProps.data.id, 'callTime') ? 'datatable-validation-error' : '')"
                                     mask="99:99"
                                     placeholder="__:__"
                                     :disabled="!canUpdate(slotProps.data)"
                                     :onchange="this.checkInterventionTimeValidity(slotProps.data)"/>
                      </template>
                    </Column>
                  </template>
                  <template v-if="this.displayColumnFor('callOrigin')">
                    <Column sortField="call_origin" field="callOrigin" :header="$t('intervention.call_origin')">
                      <template #body="slotProps">
                        <AkDropdown label=""
                                    :filter="true"
                                    v-model="slotProps.data.callOrigin"
                                    :options=origineAppelConst
                                    option-value="value"
                                    option-label="label"
                                    :disabled="!canUpdate(slotProps.data)"
                                    :class-name="(this.editionErrorsInclude(slotProps.data.id, 'callOrigin') ? 'datatable-validation-error' : '')"/>
                        <AkInputText
                            v-if="'AUTRE' === slotProps.data.callOrigin && null != slotProps.data.otherCallOrigin"
                            label=""
                            v-model="slotProps.data.otherCallOrigin"
                            :disabled="!canUpdate(slotProps.data)"
                            :class-name="''"
                        />
                      </template>
                    </Column>
                  </template>
                  <template v-if="this.displayColumnFor('axeSensIntervention')">
                    <Column field="axe_sens" :header="$t('intervention.axe_sens')">
                      <template #body="slotProps">
                        <AkDropdown :placeholder="$t('intervention.type_axe')"
                                    :filter="true"
                                    v-model="slotProps.data.typeAxe"
                                    :options=getTypeAxeInterventionConst()
                                    option-value="value"
                                    option-label="label"
                                    :show-required-symbol="false"
                                    :show-clear="canUpdate(slotProps.data)"
                                    :disabled="!canUpdate(slotProps.data)"
                                    :class-name="(this.editionErrorsInclude(slotProps.data.id, 'typeAxe') ? 'datatable-validation-error' : '')"/>

                        <AkDropdown :placeholder="$t('intervention.axe')"
                                    :filter="true"
                                    v-model="slotProps.data.axeInterventionId"
                                    v-if="slotProps.data.typeAxe"
                                    :options=axeInterventionList
                                    option-value="id"
                                    option-label="libelle"
                                    :show-required-symbol="false"
                                    :show-clear="canUpdate(slotProps.data)"
                                    :disabled="!canUpdate(slotProps.data)"
                                    :class-name="(this.editionErrorsInclude(slotProps.data.id, 'axeInterventionId') ? 'datatable-validation-error' : '')"/>

                        <template v-if="slotProps.data.axeInterventionId && slotProps.data.typeAxe !== 'SECTION_COURANTE'">
                          <AkInputText :placeholder="$t('intervention.no_echangeur')"
                                       v-model="slotProps.data.numeroEchangeur"
                                       v-if="slotProps.data.typeAxe === 'ECHANGEUR'"
                                       :class-name="(this.editionErrorsInclude(slotProps.data.id, 'numeroEchangeur') ? 'datatable-validation-error' : '')"/>

                          <AkInputText :placeholder="$t('intervention.no_bretelle')"
                                       v-model="slotProps.data.numeroBretelle"
                                       class-name=""/>

                          <AkInputText :placeholder="$t('intervention.direction')"
                                       v-model="slotProps.data.direction"
                                       class-name=""/>
                          <!--Si ce n'est pas une autoroute c'est affiché-->
                          <AkInputText :placeholder="$t('intervention.nom_lieu')"
                                       v-if="getSelectedAxe(slotProps.data).techType !== 'A' && slotProps.data.typeAxe === 'ECHANGEUR'"
                                       v-model="slotProps.data.nomLieu"
                                       class-name=""/>
                        </template>

                        <AkDropdownMultiple
                              label=""
                              v-model="slotProps.data.sensListTmp"
                              :options=sensConst
                              option-value="value"
                              option-label="label"
                              :filter="true"
                              :disabled="!canUpdate(slotProps.data)"
                              :class-name="(this.editionErrorsInclude(slotProps.data.id, 'sens') ? 'datatable-validation-error' : '')"/>
                      </template>
                    </Column>
                  </template>
                  <template v-if="this.displayColumnFor('localisation')">
                    <Column field="localisation" :header="$t('intervention.pr_voie')">
                      <template #body="slotProps">
                        <AkInputText
                              label=""
                              v-model="slotProps.data.localisation"
                              :disabled="!canUpdate(slotProps.data)"
                              :class-name="(this.editionErrorsInclude(slotProps.data.id, 'localisation') ? 'datatable-validation-error' : '')"/>
                        <AkInputText
                              label=""
                              v-model="slotProps.data.voie"
                              :disabled="!canUpdate(slotProps.data)"
                              :class-name="(this.editionErrorsInclude(slotProps.data.id, 'voie') ? 'datatable-validation-error' : '')"/>
                      </template>
                    </Column>
                  </template>
                  <template v-if="this.displayColumnFor('heureArriveeDepart')">
                    <Column field="heure_arrivee_depart" :header="$t('intervention.heure_arrivee_depart')">
                      <template #body="slotProps">
                        <AkInputMask v-model="slotProps.data.heureArriveeSite"
                              mask="99:99"
                              placeholder="__:__"
                              :disabled="!canUpdate(slotProps.data)"
                              :onchange="this.checkInterventionTimeValidity(slotProps.data)"
                              :class-name="(this.editionErrorsInclude(slotProps.data.id, 'heureArriveeSite') ? 'datatable-validation-error' : '')"/>
                        <AkInputMask v-model="slotProps.data.heureDepartSite"
                              mask="99:99"
                              placeholder="__:__"
                              :disabled="!canUpdate(slotProps.data)"
                              :onchange="this.checkInterventionTimeValidity(slotProps.data)"
                              :class-name="(this.editionErrorsInclude(slotProps.data.id, 'heureDepartSite') ? 'datatable-validation-error' : '')"/>
                      </template>
                    </Column>
                  </template>
                  <template v-if="this.displayColumnFor('heureDebutFin')">
                    <Column field="heure_debut_fin" :header="$t('intervention.heure_debut_fin')">
                      <template #body="slotProps">
                        <AkInputMask
                              v-model="slotProps.data.heureDebut"
                              mask="99:99"
                              placeholder="__:__"
                              :disabled="!canUpdate(slotProps.data)"
                              :onchange="this.checkInterventionTimeValidity(slotProps.data)"
                              :class-name="(this.editionErrorsInclude(slotProps.data.id, 'heureDebut') ? 'datatable-validation-error' : '')"/>
                        <AkInputMask
                              v-model="slotProps.data.heureFin"
                              mask="99:99"
                              placeholder="__:__"
                              :disabled="!canUpdate(slotProps.data)"
                              :onchange="this.checkInterventionTimeValidity(slotProps.data)"
                              :class-name="(this.editionErrorsInclude(slotProps.data.id, 'heureFin') ? 'datatable-validation-error' : '')"/>
                      </template>
                    </Column>
                  </template>
                  <template v-if="this.displayColumnFor('typeIntervention')">
                    <Column field="type_intervention" :header="$t('intervention.type_intervention')">
                      <template #body="slotProps">
                        <AkDropdown
                              :filter="true"
                              label=""
                              v-model="slotProps.data.typeIntervention"
                              :options=typeInterventionConst
                              :disabled="!canUpdate(slotProps.data)"
                              option-value="value"
                              option-label="label"
                              :class-name="(this.editionErrorsInclude(slotProps.data.id, 'typeIntervention') ? 'datatable-validation-error' : '')"/>
                        <AkInputText
                            v-if="'AUTRE' === slotProps.data.typeIntervention && null !=slotProps.data.otherTypeIntervention"
                            label=""
                            :disabled="!canUpdate(slotProps.data)"
                            v-model="slotProps.data.otherTypeIntervention"
                            :class-name="''"
                        />
                      </template>
                      <AkDropdownMultiple
                              label=""
                              v-model="slotProps.data.sensListTmp"
                              :options=sensConst
                              option-value="value"
                              option-label="label"
                              :filter="true"
                              :disabled="!canUpdate(slotProps.data)"
                              :class-name="(this.editionErrorsInclude(slotProps.data.id, 'sens') ? 'datatable-validation-error' : '')"/>
                    </Column>
                  </template>
                  <template v-if="this.displayColumnFor('ddp')">
                    <Column field="ddp" :header="$t('ddp.title_short')">
                      <template #body="slotProps">
                        <AkCheckbox
                            v-model="slotProps.data.ddp"
                            style="margin-bottom: 0 !important;"
                            :disabled="!canUpdate(slotProps.data)"
                            class-name="" label=""/>
                      </template>
                    </Column>
                  </template>
                  <template v-if="this.displayColumnFor('ri')">
                    <Column field="ri" :header="$t('intervention.ri')">
                      <template #body="slotProps">
                        <AkCheckbox v-model="slotProps.data.presenceRi"
                                    style="margin-bottom: 0 !important;"
                                    :disabled="!canUpdate(slotProps.data)"
                                    class-name="" label=""/>
                      </template>
                    </Column>
                  </template>
                  <template v-if="this.displayColumnFor('observation')">
                    <Column field="observation" :header="$t('intervention.observation')">
                      <template #body="slotProps">
                        <AkInputTextArea
                            label=""
                            :rows=3
                            v-model="slotProps.data.observation"
                            @click="this.openObservationDialog(slotProps.data)"
                            :readonly="!canUpdate(slotProps.data)"
                            class-name=""/>
                      </template>
                    </Column>
                  </template>
                  <Column field="status" :header="$t('intervention.status')">
                    <template #body="slotProps">
                      <Tag :value="displayForValidationStatusConst(slotProps.data.status)"
                           :severity="getColorForValidationStatusConst(slotProps.data.status)"/>
                    </template>
                  </Column>
                </DataTable>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:extra>
      
        <AkDialog
            ref="dialogObservation"
            :auto-hide-on-validate="true"
            :validate-label="$t('close')"
            :title="$t('intervention.observation')"
            width="750px"
            :no-cancel-label="true">
          <AkInputTextArea
              label=""
              :rows=10
              :disabled="!canUpdate(this.current)"
              v-model="this.current.observation"
              class-name=""/>
        </AkDialog>
        
        <AkDialog ref="dialogDelete"
                  :auto-hide-on-validate="true"
                  :cancel-label="$t('cancel')"
                  :title="$t('intervention.delete_dialog')"
                  :validate-label="$t('validate')"
                  width="450px"
                  @validate="deleteIntervention">
          <div class="confirmation-content">
            <i class="fe fe-alert-triangle mr-1" style="font-size: 2rem"/>
            <span>{{ $t('intervention.confirm_delete') }}</span>
          </div>
        </AkDialog>
        
        <AkDialog ref="settingsDialog"
                  :auto-hide-on-validate="true"
                  :cancel-label="$t('cancel')"
                  :title="$t('intervention.settings_dialog')"
                  :validate-label="$t('validate')"
                  width="650px"
                  @validate="updateSettings()">
          <div class="confirmation-content d-flex flex-row justify-content-between" style="gap: 10px;">
            <div class="d-flex align-items-center">
              <i class="fe fe-info mr-1" style="font-size: 2rem"/>
              <div class="d-flex flex-column">
                <span>{{ $t('intervention.update_settings') }}</span>
                <span>Cocher les données que vous souhaitez voir</span>
              </div>
            </div>
            <div class="d-flex flex-column" style="gap: 10px;">
              <button :v-tooltip="$t('intervention_list.untick_all')"
                      class="btn btn-outline-primary btn-xs"
                      @click="resetUserSettings(false)">
                {{ $t('intervention_list.untick_all') }}
              </button>
              <button :v-tooltip="$t('intervention_list.tick_all')"
                      class="btn btn-outline-primary btn-xs"
                      @click="resetUserSettings(true)">
                {{ $t('intervention_list.tick_all') }}
              </button>
            </div>
          </div>
          <div class="d-flex flex-column checkbox">
            <ak-checkbox v-model="userSettings.settingsValue['noInterDirif'].value"
                         :label="$t('userSettings.interventions.noInterDirif')"
                         class-name=""
                         style="margin-bottom: 0 !important;"/>

            <ak-checkbox v-model="userSettings.settingsValue['noInterCei'].value"
                         :label="$t('userSettings.interventions.noInterCei')"
                         class-name=""
                         style="margin-bottom: 0 !important;"/>

            <ak-checkbox v-model="userSettings.settingsValue['ager'].value"
                         :label="$t('userSettings.interventions.ager')"
                         class-name=""
                         style="margin-bottom: 0 !important;"/>

            <ak-checkbox v-model="userSettings.settingsValue['uer'].value"
                         :label="$t('userSettings.interventions.uer')"
                         class-name=""
                         style="margin-bottom: 0 !important;"/>

            <ak-checkbox v-model="userSettings.settingsValue['cei'].value"
                         :label="$t('userSettings.interventions.cei')"
                         class-name=""
                         style="margin-bottom: 0 !important;"/>

            <ak-checkbox v-model="userSettings.settingsValue['auteur'].value"
                         :label="$t('userSettings.interventions.auteur')"
                         class-name=""
                         style="margin-bottom: 0 !important;"/>

            <div class="d-flex flex-row">
              <ak-checkbox v-model="origineAppel"
                           @click="toggleOrigineAppel()"
                           label="Origine de l'appel"
                           class-name=""
                           style="margin-bottom: 0 !important;"/>
              <i :class="'fe ' + (origineAppelDropdown ? 'fe-chevron-up' : 'fe-chevron-down')"
                 style="font-size: 1.5rem; cursor: pointer;position: relative; top: -4px; left: 5px;"
                 @click="() => origineAppelDropdown = !origineAppelDropdown"/>
            </div>

            <div class="pl-5" v-if="origineAppelDropdown">
              <ak-checkbox v-model="userSettings.settingsValue['callOrigin'].value"
                           :label="$t('userSettings.interventions.callOrigin')"
                           class-name=""
                           style="margin-bottom: 0 !important;"/>

              <ak-checkbox v-model="userSettings.settingsValue['callDate'].value"
                           :label="$t('userSettings.interventions.callDate')"
                           class-name=""
                           style="margin-bottom: 0 !important;"/>

              <ak-checkbox v-model="userSettings.settingsValue['callTime'].value"
                           :label="$t('userSettings.interventions.callTime')"
                           class-name=""
                           style="margin-bottom: 0 !important;"/>

              <ak-checkbox v-model="userSettings.settingsValue['observation'].value"
                           :label="$t('userSettings.interventions.observation')"
                           class-name=""
                           style="margin-bottom: 0 !important;"/>
            </div>

            <div class="d-flex flex-row">
              <ak-checkbox v-model="lieuIntervention"
                           @click="toggleLieuIntervention()"
                           label="Lieu d'intervention"
                           class-name=""
                           style="margin-bottom: 0 !important;"/>
              <i :class="'fe ' + (lieuInterventionDropdown ? 'fe-chevron-up' : 'fe-chevron-down')"
                 @click="() => lieuInterventionDropdown = !lieuInterventionDropdown"
                 style="font-size: 1.5rem; cursor: pointer;position: relative; top: -4px; left: 5px;"/>
            </div>

            <div class="pl-5" v-if="lieuInterventionDropdown">

              <ak-checkbox v-model="userSettings.settingsValue['agents'].value"
                           :label="$t('userSettings.interventions.agents')"
                           class-name=""
                           style="margin-bottom: 0 !important;"/>

              <ak-checkbox v-model="userSettings.settingsValue['axe'].value"
                           :label="$t('userSettings.interventions.axe')"
                           class-name=""
                           style="margin-bottom: 0 !important;"/>

              <ak-checkbox v-model="userSettings.settingsValue['sens'].value"
                           :label="$t('userSettings.interventions.sens')"
                           class-name=""
                           style="margin-bottom: 0 !important;"/>

              <ak-checkbox v-model="userSettings.settingsValue['voie'].value"
                           :label="$t('userSettings.interventions.voie')"
                           class-name=""
                           style="margin-bottom: 0 !important;"/>

              <ak-checkbox v-model="userSettings.settingsValue['commune'].value"
                           :label="$t('userSettings.interventions.commune')"
                           class-name=""
                           style="margin-bottom: 0 !important;"/>

              <ak-checkbox v-model="userSettings.settingsValue['heureArriveeSite'].value"
                           :label="$t('userSettings.interventions.heureArriveeSite')"
                           class-name=""
                           style="margin-bottom: 0 !important;"/>

              <ak-checkbox v-model="userSettings.settingsValue['heureDepartSite'].value"
                           :label="$t('userSettings.interventions.heureDepartSite')"
                           class-name=""
                           style="margin-bottom: 0 !important;"/>

              <ak-checkbox v-model="userSettings.settingsValue['localisation'].value"
                           :label="$t('userSettings.interventions.localisation')"
                           class-name=""
                           style="margin-bottom: 0 !important;"/>

              <ak-checkbox v-model="userSettings.settingsValue['typeAxe'].value"
                           :label="$t('userSettings.interventions.typeAxe')"
                           class-name=""
                           style="margin-bottom: 0 !important;"/>

              <ak-checkbox v-model="userSettings.settingsValue['numeroEchangeur'].value"
                           :label="$t('userSettings.interventions.no_echangeur')"
                           class-name=""
                           style="margin-bottom: 0 !important;"/>

              <ak-checkbox v-model="userSettings.settingsValue['numeroBretelle'].value"
                           :label="$t('userSettings.interventions.no_bretelle')"
                           class-name=""
                           style="margin-bottom: 0 !important;"/>

              <ak-checkbox v-model="userSettings.settingsValue['direction'].value"
                           :label="$t('userSettings.interventions.direction')"
                           class-name=""
                           style="margin-bottom: 0 !important;"/>

              <ak-checkbox v-model="userSettings.settingsValue['nomLieu'].value"
                           :label="$t('userSettings.interventions.nomLieu')"
                           class-name=""
                           style="margin-bottom: 0 !important;"/>
            </div>


            <ak-checkbox v-model="userSettings.settingsValue['inciviliteAgression'].value"
                         :label="$t('userSettings.interventions.incivilite_agression')"
                         class-name=""
                         style="margin-bottom: 0 !important;"/>
            
            <div class="d-flex flex-row">
              <ak-checkbox v-model="intervention"
                           @click="toggleIntervention()"
                           label="Intervention"
                           class-name=""
                           style="margin-bottom: 0 !important;"/>
              <i :class="'fe ' + (interventionDropdown ? 'fe-chevron-up' : 'fe-chevron-down')"
                 @click="() => interventionDropdown = !interventionDropdown"
                 style="font-size: 1.5rem; cursor: pointer;position: relative; top: -4px; left: 5px;"/>
            </div>
            <div class="pl-5" v-if="interventionDropdown">
              <ak-checkbox v-model="userSettings.settingsValue['heureDebut'].value"
                           :label="$t('userSettings.interventions.heureDebut')"
                           class-name=""
                           style="margin-bottom: 0 !important;"/>

              <ak-checkbox v-model="userSettings.settingsValue['heureFin'].value"
                           :label="$t('userSettings.interventions.heureFin')"
                           class-name=""
                           style="margin-bottom: 0 !important;"/>

              <ak-checkbox v-model="userSettings.settingsValue['circonstances'].value"
                           :label="$t('userSettings.interventions.circonstances')"
                           class-name=""
                           style="margin-bottom: 0 !important;"/>
            </div>

            <ak-checkbox v-model="userSettings.settingsValue['vehiculesImpliques'].value"
                         :label="$t('userSettings.interventions.vehiculesImpliques')"
                         class-name=""
                         style="margin-bottom: 0 !important;"/>

            <ak-checkbox v-model="userSettings.settingsValue['presenceRi'].value"
                         :label="$t('userSettings.interventions.presenceRi')"
                         class-name=""
                         style="margin-bottom: 0 !important;"/>

            <ak-checkbox v-model="userSettings.settingsValue['moyensHumains'].value"
                         :label="$t('userSettings.interventions.moyensHumains')"
                         class-name=""
                         style="margin-bottom: 0 !important;"/>

            <ak-checkbox v-model="userSettings.settingsValue['moyensMateriels'].value"
                         :label="$t('userSettings.interventions.moyensMateriels')"
                         class-name=""
                         style="margin-bottom: 0 !important;"/>

            <div class="d-flex flex-row">
              <ak-checkbox v-model="environnement"
                           @click="toggleEnvironnement()"
                           label="Environnement"
                           class-name=""
                           style="margin-bottom: 0 !important;"/>
              <i :class="'fe ' + (environnementDropdown ? 'fe-chevron-up' : 'fe-chevron-down')"
                 @click="() => environnementDropdown = !environnementDropdown"
                 style="font-size: 1.5rem; cursor: pointer;position: relative; top: -4px; left: 5px;"/>
            </div>
            <div class="pl-5" v-if="environnementDropdown">
              <ak-checkbox v-model="userSettings.settingsValue['typeIntervention'].value"
                           :label="$t('userSettings.interventions.typeIntervention')"
                           class-name=""
                           style="margin-bottom: 0 !important;"/>

              <ak-checkbox v-model="userSettings.settingsValue['precisionNiveau1'].value"
                           :label="$t('userSettings.interventions.precisionNiveau1')"
                           class-name=""
                           style="margin-bottom: 0 !important;"/>

              <ak-checkbox v-model="userSettings.settingsValue['precisionNiveau2'].value"
                           :label="$t('userSettings.interventions.precisionNiveau2')"
                           class-name=""
                           style="margin-bottom: 0 !important;"/>

              <ak-checkbox v-model="userSettings.settingsValue['etatChaussee'].value"
                           :label="$t('userSettings.interventions.etatChaussee')"
                           class-name=""
                           style="margin-bottom: 0 !important;"/>

              <ak-checkbox v-model="userSettings.settingsValue['conditionsMeteo'].value"
                           :label="$t('userSettings.interventions.conditionsMeteo')"
                           class-name=""
                           style="margin-bottom: 0 !important;"/>

              <ak-checkbox v-model="userSettings.settingsValue['intervenants'].value"
                           :label="$t('userSettings.interventions.intervenants')"
                           class-name=""
                           style="margin-bottom: 0 !important;"/>

              <ak-checkbox v-model="userSettings.settingsValue['actionsRealisees'].value"
                           :label="$t('userSettings.interventions.actionsRealisees')"
                           class-name=""
                           style="margin-bottom: 0 !important;"/>
            </div>

            <ak-checkbox v-model="userSettings.settingsValue['ddp'].value"
                         :label="$t('userSettings.interventions.ddp')"
                         class-name=""
                         style="margin-bottom: 0 !important;"/>
          </div>
        </AkDialog>
        
        <AkDialog ref="tableSettingsDialog"
                  :auto-hide-on-validate="true"
                  :cancel-label="$t('cancel')"
                  :title="$t('intervention.table_settings_dialog')"
                  :validate-label="$t('validate')"
                  width="650px"
                  @validate="updateTableSettings()">
          <div class="confirmation-content d-flex flex-row justify-content-between" style="gap: 10px;">
            <div class="d-flex align-items-center">
              <i class="fe fe-info mr-1" style="font-size: 2rem"/>
              <div class="d-flex flex-column">
                <span>{{ $t('intervention.update_table_settings') }}</span>
                <span>Cocher les données que vous souhaitez voir</span>
              </div>
            </div>
            <div class="d-flex flex-column" style="gap: 10px;">
              <button :v-tooltip="$t('intervention_list.untick_all')"
                      class="btn btn-outline-primary btn-xs"
                      @click="resetTableSettings(false)">
                {{ $t('intervention_list.untick_all') }}
              </button>
              <button :v-tooltip="$t('intervention_list.tick_all')"
                      class="btn btn-outline-primary btn-xs"
                      @click="resetTableSettings(true)">
                {{ $t('intervention_list.tick_all') }}
              </button>
            </div>
          </div>
          <ak-checkbox
              v-for="setting in Object.keys(tmpTableSettings.settingsValue)"
              :key="setting"
              v-model="tmpTableSettings.settingsValue[setting].value"
              :label="$t('tableSettings.interventions.' + setting)"
              class-name="col-12 checkbox mt-2"
              style="margin-bottom: 0 !important;"/>
        </AkDialog>
        
        <AkDialog ref="helpDialog"
                  :auto-hide-on-validate="true"
                  :cancel-label="$t('cancel')"
                  :title="$t('intervention.help_dialog')"
                  :no-validate-label="true"
                  width="650px">
          <div class="confirmation-content d-flex flex-row justify-content-between" style="gap: 10px;">
            <div class="d-flex align-items-center">
              <i class="fe fe-info mr-1" style="font-size: 2rem"/>
              <div class="d-flex flex-column">
                <span>{{ $t('intervention.help_dialog_header') }}</span>
              </div>
            </div>
          </div>
          <br>
          <div v-html="$t('intervention.help_dialog_content')"></div>
        </AkDialog>
        
        <AkDialog ref="dialogCreateAndValidate"
            :auto-hide-on-validate="true"
            :cancel-label="$t('no')"
            :title="$t('intervention.create_validate_intervention')"
            :validate-label="$t('yes')"
            width="450px"
            @validate="createAndValidate">
          <div class="confirmation-content">
            <i class="fe fe-alert-triangle mr-1" style="font-size: 2rem"/>
            <span>{{ $t('intervention.confirm_create_validate') }}</span>
          </div>
        </AkDialog>
        
      </template>
    </AkFormList>
  </template>
</template>